// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1F2BK","label":"Radio_label__373Yz","checkMark":"Radio_checkMark__2VREJ","disabled":"Radio_disabled__1An9s"};